export enum ProcessingStepSection {
  AGENT_PROCESSING_DETAILS = "Agent Processing Details",
  AGENT_PROCESSING = "Agent Processing",
  AGENT_PROGRESS = "Agent Progress",
  CACHE = "Cache",
  DATABASE_QUERY = "Database Query",
  DATABASE = "Database",
  FINAL_RESPONSE = "Final Response",
  METRICS = "Metrics",
  PROCESSING = "Processing",
  RESPONSE_SAFETY = "Response Safety",
  SAFETY_CHECK = "Safety Check",
  TOOL_EXECUTION_DETAILS = "Tool Execution Details",
  TOOL_PROGRESS = "Tool Progress",
  TRACE_DETAILS = "Trace Details",
  TRACING = "Tracing",
}

export enum ChatSection {
  CHAT = "Chat",
}

export type ChatResponseSection = ProcessingStepSection | ChatSection;

export enum ChatSectionStatus {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  ERROR = "error",
  NEW_CONVO = "new_conversation",
}

// final: Whether this is the final message in a sequence (default: True).
//     When False, the client should expect more messages to follow.
// stream: Whether this is a streaming message (default: False).
//     When True, the client should append this text to existing content.
export interface ChatResponse {
  final: boolean;
  stream: boolean;

  // Commented because no idea what this is.
  // status: boolean;
  response: string; // JSON
  section: ChatResponseSection;
  section_status: ChatSectionStatus;

  // Monotonically increasing sequence number stamped by the backend.
  // Used to reorder processing steps that arrive out of logical order
  // due to the OTel BatchSpanProcessor worker thread flushing asynchronously.
  seq?: number;
}

export interface NewConvoResponse {
  conversation_id: string;
  title: string;
}

export interface OriginalMetricsResponse {
  type: "processing_metrics";
  metrics: {
    "Total tokens": number;
    "Input tokens"?: number;
    "Output tokens"?: number;
    "Execution time": string;
    "Tools used": string[];
    "Tool usage counts"?: Record<string, number>;
  };
}

export interface MetricsResponse {
  tokens: number;
  inputTokens: number;
  outputTokens: number;
  time: string;
  tools: string[];
  toolCounts: Record<string, number>;
}
